export function TrustPage() {
  return <div className="text-gray-500">Trust &amp; safety page - coming soon.</div>
}
